import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "./Subscribe.css";
import { useLocation } from 'react-router-dom';


const sendOtp = '/send-otp'
const SendOtp = () => {
    const [loading, setLoading] = useState(false);


    const location = useLocation();
    const initialFullMsisdn = location.state?.msisdn || "";
    const initialMsisdn = initialFullMsisdn.startsWith("94")
        ? initialFullMsisdn.slice(2)
        : initialFullMsisdn;


    const [msisdn, setMsisdn] = useState(initialMsisdn);
    console.log("MSISDN", msisdn)
    const navigate = useNavigate();
    const bundle_id = '939'

    const handleSendOTP = async () => {
        const trimmed = msisdn.trim();

        if (!/^\d{9}$/.test(trimmed)) {
            toast.error("Please enter a valid 9-digit mobile number.");
            return;
        }

        const fullMsisdn = "94" + trimmed;
        const data = {
            number: fullMsisdn,
            bundle_id
        };

        setLoading(true); 
        try {
    const res = await axios.post(sendOtp, data);
    console.log("generate otp", res.data);

    if (res.data.code === 0) {
        toast.success(res.data.message);
        setTimeout(() => {
            navigate("/otp-validation", { state: { msisdn: fullMsisdn } });
        }, 500);
    } else {
        // Handle errors returned in a success response
        const apiError =
            res.data?.errors?.number?.[0] || // specific number error
            res.data?.message || // fallback message
            "Failed to send OTP.";

        toast.error(apiError);
    }
} catch (err) {
    console.error("OTP error", err);
    toast.error("Something went wrong. Please try again.");
}

        // try {
        //     const res = await axios.post(sendOtp, data);
        //     console.log("generate otp", res.data);

        //     if (res.data.code === 0) {
        //         toast.success(res.data.message);
        //         setTimeout(() => {
        //             navigate("/otp-validation", { state: { msisdn: fullMsisdn } });
        //         }, 500);
        //     } else {
        //         toast.error(res.data.message || "Failed to send OTP.");
        //         navigate("/otp");
        //     }
        // } catch (err) {
        //     console.error("OTP error", err);
        //     toast.error("Something went wrong. Please try again.");
        // } 
        
        finally {
            setLoading(false);
        }
    };

    return (
        <div className="subscribe-container">
            <img src="/assets/images/newLogo.png" alt="Zeropoint Logo" className="subscribe-logo" />
            <div className="subscribe-card">
                <h1 className="subscribe-title">Subscribe to Zeropoint</h1>
                <p className="subscribe-desc">Enter your number to receive an OTP</p>
                <div className="prefix-input-wrapper">
                    <span className="prefix">94</span>
                    <input
                        type="tel"
                        placeholder="Enter your mobile number"
                        value={msisdn}
                        onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, ""); // remove non-digits
                            if (val.length <= 9) {
                                setMsisdn(val); // ✅ allow up to 9 digits
                            }
                        }}
                        className="subscribe-input"
                    />



                </div>
                <button
                    onClick={handleSendOTP}
                    className="subscribe-button"
                    disabled={loading}
                >
                    {loading ? "Sending..." : "Send OTP"}
                </button>

            </div>
            <ToastContainer position="top-center" autoClose={3000} />
        </div>
    );
};

export default SendOtp;
